import React, {useEffect, useState} from "react";
import {HtmlPreviewer} from "./html-previewer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-solid-svg-icons/faTimes";
import {faDownload} from "@fortawesome/pro-solid-svg-icons/faDownload";
import {faSpinner} from "@fortawesome/pro-solid-svg-icons/faSpinner";

import Lang from 'lang.js'
import messages from '../js/messages'
const lang = new Lang({messages, fallback: 'nl'});

const PdfPreviewModal = ({isOpen, content, toggleModal, orientation, downloadUrl = null}) => {

    useEffect(() => {
        if (!document.body) {
            return;
        }
        document.body.classList.toggle('modal-open', !!isOpen);

        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [isOpen]);

    if (!isOpen) {
        return '';
    }
    return <>
        <style>{`

.pdf-modal-overlay {
  position: fixed;
  z-index:999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
}

.pdf-modal-content {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: min(80vw, ${orientation === 'landscape' ? '1000px' : '60vh'});
  margin-top: 25px;
  margin-left:auto;
  margin-right:auto;
  position:relative;
}

.pdf-modal-download {
    position:absolute;
    top: -15px;
    right: 45px;
    z-index: 1;
    width: 110px;
    height: -30px;

    cursor: pointer;
    background-color: #d3d3d3; /* Lichtgrijze kleur */
}

.pdf-modal-close {
    position:absolute;
    top: -15px;
    right: -15px;
    z-index: 1;
    width: 30px;
    height: 30px;
    cursor: pointer;
    background-color: #d3d3d3; /* Lichtgrijze kleur */
}
            `}
        </style>

        <div className="pdf-modal-overlay" onClick={toggleModal}>
            <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
                {!!downloadUrl &&
                    <Download downloadUrl={downloadUrl} />
                }
                <div className="pdf-modal-close rounded-circle p-1 d-flex align-items-center justify-content-center" onClick={toggleModal}>
                    <FontAwesomeIcon icon={faTimes} fixedWidth={true} />
                </div>
                <HtmlPreviewer html={content}/>
            </div>
        </div>
    </>
}
export default PdfPreviewModal;


function Download({downloadUrl}) {
    const [isLoading, setIsLoading] = useState(false);

    const download = async (e) => {
        if (isLoading) {
            return;
        }
        e.stopPropagation();
        setIsLoading(true);
        try {
            const response = await fetch(downloadUrl);
            if (!response.ok) {
                throw new Error("Netwerk fout");
            }
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "brochure-lq.pdf";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        } catch (error) {
            console.error("Download mislukt:", error);
        }
        setIsLoading(false);
    };

    return (
        <button className="pdf-modal-download p-1 d-flex align-items-center justify-content-center border-0 align-middle" style={{borderRadius: '30px'}} disabled={isLoading} onClick={download}>
            {!isLoading ?
                <FontAwesomeIcon icon={faDownload} className="mr-1" fixedWidth={true} />
                :
                <FontAwesomeIcon icon={faSpinner} spin={true} className="mr-1" fixedWidth={true} />
            }
            {lang.get('portal.download')}
        </button>
    );
}
